import React from 'react'
import { useHistory } from 'react-router-dom'
import { Box, Typography, Button } from 'transfix-ui/core'
import { ReactComponent as NoLoadsIllustration } from 'apps/fleet-planner/components/illustrations/NoLoadsIllustration.svg'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks/useFMSAnalytics'

export const LoadUnavailable = () => {
  const { trackEvent } = useFMSAnalytics()
  const history = useHistory()
  const startNewSearchHandler = () => {
    trackEvent('Marketplace Load', 'VIEWED_LOAD_NOT_AVAILABLE')
    history.push('/book')
  }
  return (
    <Box display='flex' alignItems='center' justifyContent='center' flexDirection='column'>
      <NoLoadsIllustration />
      <Box pt={2}>
        <Typography variant='subtitle1'>This load is no longer available.</Typography>
      </Box>
      <Box pt={3}>
        <Button color='primary' size='large' fullWidth onClick={startNewSearchHandler}>
          Try Another Search
        </Button>
      </Box>
    </Box>
  )
}
